<div class="p-4">
	<div class="mb-4">
		<div class="avatar-lg mx-auto">
			<div class="avatar-title bg-light text-primary display-5 rounded-circle shadow">
				<i class="ri-mail-line"></i>
			</div>
		</div>
	</div>
	<div class="p-2 mt-4">
		<div class="text-muted text-center mb-4 mx-lg-3">
			<h4>{{ 'ASSESSMENTAPP.VERIFICATION_CODE' | translate }}</h4>
			<p>
				{{ 'ASSESSMENTAPP.SIX_DIGIT' | translate }} 
				<span class="fw-semibold">{{ context === 'case' ? examinee.email : examinee ? examinee.person.email : 'Unknown' }}</span>
			</p>
		</div>
		<form>
			<div class="row twostep-input ltr">
				<ng-otp-input [config]="config" (onInputChange)="onOtpChange($event)"></ng-otp-input>
			</div>
		</form>
		<!-- end form -->
		<div class="mt-3 text-center">
			<button type="button" (click)="confirm()" [disabled]="submitted" class="btn btn-success">{{ 'ASSESSMENTAPP.CONFIRM' | translate }}</button>
		</div>
	</div>
</div>
<div *ngIf="timerRunning" class="mt-4 text-center">
  <p class="mb-0">
		{{ 'ASSESSMENTAPP.RESEND_CODE' | translate }} {{ countdown }} {{ 'ASSESSMENTAPP.SECONDS' | translate }}.
	</p>
</div>
<div *ngIf="!timerRunning" class="mt-4 text-center">
  <p class="mb-0">
		{{ 'ASSESSMENTAPP.RESEND_QUESTION' | translate }} 
		<a type="button" (click)="resend()" class="fw-semibold text-primary text-decoration-underline"> {{ 'ASSESSMENTAPP.RESEND' | translate }} </a>
	</p>
</div>